export const resourceStatus = {
  resourceStatusId: { key: "resourceStatusId" },
  code: { key: "code" },
  description: { key: "description" },
};

export const mapResourceStatusOptions = (list = []) =>
  list.map((item) => ({
    label: item.name,
    value: item.id,
  }));
